import { useState, useEffect } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { Card, CardContent } from '@/components/ui/card'
import { Separator } from '@/components/ui/separator'
import { Button } from '@/components/ui/button'
import { LoginForm } from './components/LoginForm'
import { login } from '@/services/auth/authService'
import { useAuthStore } from '@/stores/auth-store'
import { cn } from '@/lib/utils'

export function LoginPage() {
  const navigate = useNavigate()
  const location = useLocation()
  const isLoading = useAuthStore((state) => state.isLoading)
  const [error, setError] = useState<string | null>(null)
  const [shakeKey, setShakeKey] = useState(0)

  const from = (location.state as { from?: { pathname: string } })?.from?.pathname || '/'

  useEffect(() => {
    localStorage.clear()
    sessionStorage.clear()
    document.cookie.split(';').forEach((cookie) => {
      const eqPos = cookie.indexOf('=')
      const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim()
      document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`
    })
  }, [])

  const handleLogin = async (email: string, password: string, _rememberMe: boolean) => {
    setError(null)
    const result = await login({ email, password })
    if (result.success) {
      navigate(from, { replace: true })
    } else {
      setError(result.message)
      setShakeKey((k) => k + 1)
    }
  }

  return (
    <>
      <Card
        key={shakeKey}
        className={cn('shadow-xl shadow-primary/5', shakeKey > 0 && 'animate-shake')}
      >
        <CardContent className="space-y-4 pt-6">
          <LoginForm onSubmit={handleLogin} isLoading={isLoading} error={error} />

          <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <Separator className="w-full" />
            </div>
            <div className="relative flex justify-center text-xs uppercase">
              <span className="bg-card px-2 text-muted-foreground">or</span>
            </div>
          </div>

          <Button variant="outline" className="w-full" type="button" disabled>
            Continue with SSO
          </Button>
        </CardContent>
      </Card>

      {/* Brand-book-style keyboard hint */}
      <p className="mt-6 text-center font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground/70">
        Press <span className="text-primary">⏎</span> to sign in
      </p>
    </>
  )
}
